import axios from 'axios';
import { SURVEY_ENDPOINT } from '../utils/Constants';

const useSurveyService = () => {
    async function getSurveyQuestion(uniqueId) {
        if(uniqueId?.uniqueId !== undefined && uniqueId?.uniqeId !== null && uniqueId?.uniqieId !== '' ) {
            const serviceURL = `${process.env.REACT_APP_APIURL}${SURVEY_ENDPOINT.Survey}?uniqueId=${uniqueId.uniqueId}`;
            return await axios.get(serviceURL);
        }
    }

    async function submitSurvey(uniqueId, questions) {
        return await axios.post(`${process.env.REACT_APP_APIURL}${SURVEY_ENDPOINT.Survey}`,
            {
                questions: questions.questions,
                uniqueId: uniqueId.uniqueId                
            },
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access-Control-Allow-Origin': '*',
                },
            });
    }

    async function getWhiteListData(uniqueId){
        console.log(uniqueId)
        return await axios.post(`${process.env.REACT_APP_APIURL}${SURVEY_ENDPOINT.GetWhiteListData}`,
            {
                uniqueId: uniqueId                
            },
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access-Control-Allow-Origin': '*',
                },
            });
    }

     async function getEngagementSurveyQuestions(emailAddress, namedSurveyId) {
        if(emailAddress !== undefined && emailAddress !== null) {
            let serviceURL = `${process.env.REACT_APP_APIURL}${SURVEY_ENDPOINT.GetEngagementSurveyQuestions}/${emailAddress}`;
            if(namedSurveyId){
                serviceURL = `${process.env.REACT_APP_APIURL}${SURVEY_ENDPOINT.GetEngagementSurveyQuestions}/${emailAddress}/${namedSurveyId}`;
            }
            
            return await axios.get(serviceURL);
        }
    }

    async function submitEngagementSurvey(emailAddress, surveyName, surveyFName, surveyLName, questions, namedSurveyId) {
        const postData = {
                questions: questions.questions,
                name: surveyName.surveyName,
                fName: surveyFName.surveyFName,
                lName: surveyLName.surveyLName,
                emailAddress: emailAddress.emailAddress ,
                namedSurveyId: namedSurveyId
            };

            console.log('submit engagement survey post data', postData);
        return axios.post(`${process.env.REACT_APP_APIURL}${SURVEY_ENDPOINT.PostEngagementSurvey}`,
            postData,
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access-Control-Allow-Origin': '*',
                },
            });
    }

    return {
        getSurveyQuestion,
        getEngagementSurveyQuestions,
        submitSurvey,
        submitEngagementSurvey,
        getWhiteListData    };

};

export default useSurveyService;